<div class="container">
    <div class="block-title">
        <div class="title"> {{ 'SHARED.EXTERNAL.CMR.EVENTS.CAPTION' | translate }} </div>
    </div>
    
    <shared-cmr-events-list [events]="getListEvents()">
    </shared-cmr-events-list>
</div>